import { gateway } from "../../../gateway";
import { TimeSheetSearchSuggestionsParams, TimeSheetSearchSuggestionsResponse } from "../interfaces/time-sheet.interfaces";

export const getTimeSheetSearchSuggestions = async (params: TimeSheetSearchSuggestionsParams): Promise<TimeSheetSearchSuggestionsResponse> => {
  const { data } = await gateway.get<TimeSheetSearchSuggestionsResponse>("/timesheets/search-suggestions", { params });

  return data;
};
